import React, { useState } from "react";
import Footer from "../components/Footer";
import BlogProps from '../components/BlogProps'
import Img1 from "../assets/blogpage/1.jpg";
import Img2 from "../assets/blogpage/2.jpg";
import Img3 from "../assets/blogpage/3.jpg";
import Img4 from "../assets/blogpage/4.jpg";
import Img5 from "../assets/blogpage/5.jpg";
import Img6 from "../assets/blogpage/6.jpg";
import Img7 from "../assets/blogpage/7.jpg";
import Recent1 from "../assets/blogpage/recent1.jpg";
import Recent2 from "../assets/blogpage/recent2.jpg";
import Recent3 from "../assets/blogpage/recent3.jpg";
import Recent4 from "../assets/blogpage/recent4.jpg";
import Recent5 from "../assets/blogpage/recent5.jpg";
import Recent6 from "../assets/blogpage/recent6.jpg";

function Blog() {

  const [showDropdown, setShowDropdown] = useState(null);

  const handleDropdown = (category) => {
    setShowDropdown(category === showDropdown ? null : category);
  };
  
  return (
    <>
      <section>
        <div className="login-banner relative justify-center flex">
          <h1 className="text-white absolute bottom-[25px] text-[3rem] font-bold">
            Blog
          </h1>
        </div>
        {/* blog */}
        <div className="py-[5rem] lg:py-[10rem] container lg:gap-16 page-padding grid lg:grid-cols-[64fr_35fr] grid-cols-1 gap-32">
          {/* blog */}
          <div className="flex flex-col gap-28">
            <BlogProps img={Img1} title="Yoga For Everyone in 2022" />
            <BlogProps
              img={Img2}
              title="Getting Back Into CrossFit After Vacation"
            />
            <BlogProps img={Img3} title="Meet Fitness Ambassador Grace" />
            <BlogProps img={Img4} title="The Best are European Materls Direct" />
            <BlogProps
              img={Img5}
              title="Give your Fitness a Boost with our Gym"
            />
            <BlogProps
              img={Img6}
              title="How to Get Fit Your Kids Moving Throughout The Summer"
            />
            <BlogProps
              img={Img7}
              title="Give your fitness a boost with our new gym challenge"
            />
          </div>

          {/* sidebar */}
          <div>
            {/* form */}
            <form className="flex">
              <input
                className="border-solid border-[1px] text-[#444] text-[16px] font-medium h-[60px] py-[5px] px-[20px] w-full rounded-tl-xl rounded-bl-xl outline-none"
                type="search"
                placeholder="Search..."
              ></input>
              <button type="submit">
                <i className="fa-solid fa-magnifying-glass bg-primary text-white text-[23px] h-[60px] w-[60px] rounded-br-xl rounded-tr-xl pt-[18px]"></i>
              </button>
            </form>

            {/* categories */}
            <div className="flex flex-col bg-[#f8f8f8] my-[35px] p-[30px]">
              <p className="text-[18px] text-black font-bold mb-5">
                Categories
              </p>
              <span className="w-[40px] h-[3.5px] bg-primary"></span>
              <ul className="text-[16px] text-[#7e7e7e] font-medium mt-10">
              <li className="cursor-pointer flex justify-between border-b border-[#dcd9d9] pb-6 mb-10 hover:text-primary ease-in duration-200" onClick={() => handleDropdown("bodyBuilding")}>
              	<p>
                  <i className="text-[13px] fa-solid fa-chevron-right"></i>
                    &nbsp; Body Building
               </p>
            <span>(4)</span>
          </li>
          {showDropdown === "bodyBuilding" && (
            <div className="pb-[2rem]">
              <p>This is a random content for Body Building dropdown.</p>
              <p>You can add any content you want here.</p>
            </div>
          )}


                <li className="cursor-pointer flex justify-between border-b border-[#dcd9d9] pb-6 mb-10 hover:text-primary ease-in duration-200">
                  <p>
                    <i className="text-[13px]  fa-solid fa-chevron-right"></i>
                    &nbsp; Boxing
                  </p>
                  <span>(4)</span>
                </li>

                <li className="cursor-pointer flex justify-between border-b border-[#dcd9d9] pb-6 mb-10 hover:text-primary ease-in duration-200">
                  <p>
                    <i className="text-[13px]  fa-solid fa-chevron-right"></i>
                    &nbsp; Crossfit
                  </p>
                  <span>(4)</span>
                </li>

                <li className="cursor-pointer flex justify-between border-b border-[#dcd9d9] pb-6 mb-10 hover:text-primary ease-in duration-200">
                  <p>
                    <i className="text-[13px]  fa-solid fa-chevron-right"></i>
                    &nbsp; Fitness
                  </p>
                  <span>(4)</span>
                </li>

                <li className="flex justify-between border-b border-[#dcd9d9] pb-6 mb-10 hover:text-primary ease-in duration-200">
                  <p>
                    <i className="text-[13px] fa-solid fa-chevron-right"></i>
                    &nbsp; Meditation
                  </p>
                  <span>(4)</span>
                </li>

                <li className="cursor-pointer flex justify-between border-b border-[#dcd9d9] pb-6 mb-10 hover:text-primary ease-in duration-200">
                  <p>
                    <i className="text-[13px]  fa-solid fa-chevron-right"></i>
                    &nbsp; Yoga
                  </p>
                  <span>(4)</span>
                </li>
              </ul>
            </div>
            {/* recent posts */}
            <div className="flex flex-col bg-[#f8f8f8] my-[35px] p-[30px]">
              <p className="text-[18px] text-black font-bold mb-5">
                Recent Posts
              </p>
              <span className="w-[40px] h-[3.5px] bg-primary mb-7"></span>
              <div className="flex flex-col gap-7">
                {/*  */}
                <div className="flex gap-8">
                  <img src={Recent1} alt="recent_img" className="w-[10rem]" />
                  <div className="flex flex-col gap-4 justify-center">
                    <p className="text-[14px] text-grayTxt font-medium">
                      March 22, 2022
                    </p>
                    <p className="text-[14px] lg:text-[16px] text-black hover:text-primary ease-in duration-200 cursor-pointer font-bold">
                      Yoga For Everyone in 2022
                    </p>
                  </div>
                </div>
                {/*  */}
                <div className="flex gap-8">
                  <img src={Recent2} alt="recent_img" className="w-[10rem]" />
                  <div className="flex flex-col gap-4 justify-center">
                    <p className="text-[14px] text-grayTxt font-medium">
                      March 22, 2022
                    </p>
                    <p className="text-[14px] lg:text-[16px] text-black hover:text-primary ease-in duration-200 cursor-pointer font-bold">
                      Getting Back Into CrossFit
                    </p>
                  </div>
                </div>
                {/*  */}
                <div className="flex gap-8">
                  <img src={Recent3} alt="recent_img" className="w-[10rem]" />
                  <div className="flex flex-col gap-4 justify-center">
                    <p className="text-[14px] text-grayTxt font-medium">
                      March 22, 2022
                    </p>
                    <p className="text-[14px] lg:text-[16px] text-black hover:text-primary ease-in duration-200 cursor-pointer font-bold">
                      Meet Fitness Abassador Grace
                    </p>
                  </div>
                </div>
                {/*  */}
                <div className="flex gap-8">
                  <img src={Recent4} alt="recent_img" className="w-[10rem]" />
                  <div className="flex flex-col gap-4 justify-center">
                    <p className="text-[14px] text-grayTxt font-medium">
                      March 22, 2022
                    </p>
                    <p className="text-[16px] text-black hover:text-primary ease-in duration-200 cursor-pointer font-bold">
                      The best are European Meditation Practitioner
                    </p>
                  </div>
                </div>
                {/*  */}
                <div className="flex gap-8">
                  <img src={Recent5} alt="recent_img" className="w-[10rem]" />
                  <div className="flex flex-col gap-4 justify-center">
                    <p className="text-[14px] text-grayTxt font-medium">
                      March 22, 2022
                    </p>
                    <p className="text-[16px] text-black hover:text-primary ease-in duration-200 cursor-pointer font-bold">
                      Learn Boxing With Our Trainer John
                    </p>
                  </div>
                </div>
                {/*  */}
                <div className="flex gap-8">
                  <img src={Recent6} alt="recent_img" className="w-[10rem]" />
                  <div className="flex flex-col gap-4 justify-center">
                    <p className="text-[14px] text-grayTxt font-medium">
                      March 22, 2022
                    </p>
                    <p className="text-[16px] text-black hover:text-primary ease-in duration-200 cursor-pointer font-bold">
                      How To Get Lean For The Summer
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* popular tags */}
            <div className="flex flex-col bg-[#f8f8f8] my-[35px] p-[30px]">
              <p className="text-[18px] text-black font-bold mb-5">
                Popular Tags
              </p>
              <span className="w-[40px] h-[3.5px] bg-primary mb-7"></span>
              <div className="flex gap-3 text-[16px] text-grayTxt font-medium flex-wrap">
                <p className="bg-white py-[4px] px-[14px] hover:text-primary ease-in duration-200 cursor-pointer">
                  #Crossfit
                </p>
                <p className="bg-white py-[4px] px-[14px] hover:text-primary ease-in duration-200 cursor-pointer">
                  #Fitness
                </p>
                <p className="bg-white py-[4px] px-[14px] hover:text-primary ease-in duration-200 cursor-pointer">
                  #Gym
                </p>
                <p className="bg-white py-[4px] px-[14px] hover:text-primary ease-in duration-200 cursor-pointer">
                  #Meditation
                </p>
                <p className="bg-white py-[4px] px-[14px] hover:text-primary ease-in duration-200 cursor-pointer">
                  #Running
                </p>
                <p className="bg-white py-[4px] px-[14px] hover:text-primary ease-in duration-200 cursor-pointer">
                  #Workout
                </p>
                <p className="bg-white py-[4px] px-[14px] hover:text-primary ease-in duration-200 cursor-pointer">
                  #Yoga
                </p>
                <p className="bg-white py-[4px] px-[14px] hover:text-primary ease-in duration-200 cursor-pointer">
                  #Boxing
                </p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Blog;
